import { getMicroAppPath } from "./utils";
import { SUB_APP_NAME } from "./subApps";

const chargingStation = [
  {
    name: "充电桩场站管理",
    title: "menu.0101",
    key: "0101",
    path: "/station/chargingStation/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/configManager/stubGroupList"),
  },
  {
    name: "新建场站",
    title: "menu.010101",
    key: "010101",
    path: "/station/chargingStation/add",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/configManager/addStubGroup"),
    hideInMenu: true,
  },
  {
    name: "编辑场站",
    title: "menu.010102",
    key: "010102",
    path: "/station/chargingStation/edit",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/configManager/editStubGroup"),
    hideInMenu: true,
  },
  {
    name: "场站拓扑图",
    title: "menu.010103",
    key: "010103",
    path: "/station/chargingStation/topology",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/configManager/stubGroupTuPu"),
    hideInMenu: true,
  },
];

const stationMonitor = [
  {
    name: "场站监控",
    title: "menu.550256",
    key: "550256",
    path: "/station/stationMonitor",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/configManager/stationMonitor"),
  },
];

const charger = [
  {
    name: "充电桩管理",
    title: "menu.0107",
    key: "0107",
    path: "/equipment/charger/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/equipment"),
  },
  {
    name: "新建充电桩",
    title: "menu.010701",
    key: "010701",
    path: "/equipment/charger/add",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/equipment/add"),
    hideInMenu: true,
  },
  {
    name: "编辑充电桩",
    title: "menu.010702",
    key: "010702",
    path: "/equipment/charger/edit",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/equipment/edit"),
    hideInMenu: true,
  },
  {
    name: "充电桩详情",
    title: "menu.010703",
    key: "010703",
    path: "/equipment/charger/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/equipment/detail"),
    hideInMenu: true,
  },
  {
    name: "箱充详情数据",
    title: "menu.010711",
    key: "010711",
    path: "/equipment/charger/boxChargeDetail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/equipment/boxChargeDetail"),
    hideInMenu: true,
  },
  {
    name: "温度监测",
    title: "menu.temperatureMonitoring",
    key: "temperatureMonitoring",
    path: "/equipment/charger/temperatureMonitoring",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/equipment/temperatureMonitoring"),
    hideInMenu: true,
  },
  {
    name: "充电桩拓扑图",
    title: "menu.808649",
    key: "chargerTopology",
    path: "/equipment/charger/chargerTopology",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/equipment/chargerTopology"),
    hideInMenu: true,
  },
];

const chargingConnector = [
  {
    name: "充电枪管理",
    title: "menu.0102",
    key: "0102",
    path: "/equipment/chargingConnector/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/gun/list"),
  },
  {
    name: "充电枪详情",
    title: "menu.010202",
    key: "010202",
    path: "/equipment/chargingConnector/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/gun/detail"),
    hideInMenu: true,
  },
  {
    name: "检测信息",
    title: "menu.731278",
    key: "731278",
    path: "/equipment/chargingConnector/detect",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/gun/detectionInformation"),
    hideInMenu: true,
  },
  {
    name: "充电枪故障详情",
    title: "menu.523682",
    key: "523682",
    path: "/equipment/chargingConnector/faultDetail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/gun/faultDetail"),
    hideInMenu: true,
  },
  {
    name: "配置下发",
    title: "menu.010201",
    key: "010201",
    path: "/equipment/chargingConnector/configInfo",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/gun/configInfo"),
    hideInMenu: true,
  },
];

const warehouseCharger = [
  {
    name: "仓库充电桩管理",
    title: "menu.0103",
    key: "0103",
    path: "/equipment/warehouseCharger/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/configManager/warehouseEquipment/list"),
  },
  {
    name: "仓库充电桩详情",
    title: "menu.010301",
    key: "010301",
    path: "/equipment/warehouseCharger/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/configManager/warehouseEquipment/detail"),
    hideInMenu: true,
  },
];

const warehouseChargingConnector = [
  {
    name: "仓库充电枪管理",
    title: "menu.0108",
    key: "0108",
    path: "/equipment/warehouseChargingConnector/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/configManager/warehouseChargingGun/list"),
  },
  {
    name: "仓库充电枪详情",
    title: "menu.010801",
    key: "010801",
    path: "/equipment/warehouseChargingConnector/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/configManager/warehouseChargingGun/detail"),
    hideInMenu: true,
  },
];

const materialBom = [
  {
    name: "物料BOM管理",
    title: "menu.0111",
    key: "0111",
    path: "/equipment/materialBom",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/materialBom"),
  },
];

const distributionCabinet = [
  {
    name: "配电柜管理",
    title: "menu.0104",
    key: "0104",
    path: "/equipment/distributionCabinet/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/configManager/powerBoxList"),
  },
];

const batterySwapCabinet = [
  {
    name: "新设备管理",
    title: "menu.OMC_EP_950393",
    key: "OMC_EP_950393",
    path: "/equipment/batterySwapCabinet/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/batterySwapCabinet/list"),
  },
];

const moduleRoutes = [
  {
    name: "模块管理",
    title: "menu.0105",
    key: "0105",
    path: "/equipment/module/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/moduleManagement/list"),
  },
  {
    name: "历史设备",
    title: "menu.010501",
    key: "010501",
    path: "/equipment/module/history",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/moduleManagement/historyStubInfo"),
    hideInMenu: true,
  },
  {
    name: "模块信息",
    title: "menu.010502",
    key: "010502",
    path: "/equipment/module/info",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/moduleManagement/moduleInfo"),
    hideInMenu: true,
  },
  {
    name: "模块信息",
    title: "menu.010503",
    key: "010503",
    path: "/equipment/module/data",
    microAppPath: getMicroAppPath(
      SUB_APP_NAME.EP,
      "/config/moduleManagement/powerModuleChargeCourse",
    ),
    hideInMenu: true,
  },
];

const energyEquipment = [
  {
    name: "能源设备管理",
    title: "menu.0109",
    key: "0109",
    path: "/equipment/energy/list",
    component: "./configManager/energyEquipment/List",
  },
  {
    name: "能源设备详情",
    title: "menu.010901",
    key: "010901",
    path: "/equipment/energy/detail",
    component: "./configManager/energyEquipment/Detail",
    hideInMenu: true,
  },
  {
    name: "配置信息",
    title: "menu.010902",
    key: "010902",
    path: "/equipment/energy/configInfo",
    component: "./configManager/energyEquipment/ConfigInfo",
    hideInMenu: true,
  },
  {
    name: "通信拓扑",
    title: "menu.470879",
    key: "470879",
    path: "/equipment/energy/communicationTopology/:topoParams",
    microAppPath: getMicroAppPath(
      SUB_APP_NAME.ENERGY,
      "/maintenance/microTopo/topo/:topoParams",
    ),
    hideInMenu: true,
  },
  {
    name: "EUC通信拓扑",
    title: "menu.539536",
    key: "539536",
    path: "/equipment/energy/communicationTopology/:topoParams/EUCTopo/:eucParams",
    microAppPath: getMicroAppPath(
      SUB_APP_NAME.ENERGY,
      "/maintenance/microTopo/topo/:topoParams/EUCTopo/:eucParams",
    ),
    hideInMenu: true,
  },
  {
    name: "控制拓扑",
    title: "menu.518842",
    key: "518842",
    path: "/equipment/energy/controlTopology",
    microAppPath: getMicroAppPath(SUB_APP_NAME.ENERGY, "/maintenance/microTopo/controlParams"),
    hideInMenu: true,
  },
  {
    name: "离网拓扑",
    title: "menu.396063",
    key: "396063",
    path: "/equipment/energy/gridoffTopo",
    microAppPath: getMicroAppPath(SUB_APP_NAME.ENERGY, "/maintenance/microTopo/gridoffTopo"),
    hideInMenu: true,
  },
];

const businessEnergy = [
  {
    name: "工商能源设备管理",
    title: "menu.OMC_EP_834620",
    key: "OMC_EP_834620",
    path: "/equipment/businessEnergy/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/businessEnergy/list"),
  },
  {
    name: "工商能源设备详情",
    title: "menu.OMC_EP_834621",
    key: "OMC_EP_834621",
    path: "/equipment/businessEnergy/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/businessEnergy/detail"),
    hideInMenu: true,
  },
];

const highVoltageEquipment = [
  {
    name: "高压设备管理",
    title: "menu.0106",
    key: "0106",
    path: "/equipment/highVoltage/list",
    component: "./HighVDevice",
  },
  {
    name: "高压设备新建",
    title: "menu.010601",
    key: "010601",
    path: "/equipment/highVoltage/add",
    component: "./HighVDevice/Detail",
    hideInMenu: true,
  },
  {
    name: "高压设备编辑",
    title: "menu.010602",
    key: "010602",
    path: "/equipment/highVoltage/edit",
    component: "./HighVDevice/Detail",
    hideInMenu: true,
  },
  {
    name: "高压设备详情",
    title: "menu.010603",
    key: "010603",
    path: "/equipment/highVoltage/detail",
    component: "./HighVDevice/Detail",
    hideInMenu: true,
  },
];

const deviceTopology = [
  {
    name: "设备拓扑",
    title: "menu.040411",
    key: "040411",
    path: "/equipment/topology/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/deviceTopology"),
  },
  {
    name: "整桩设备",
    title: "menu.435731",
    key: "435731",
    path: "/equipment/topology/whole",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/deviceTopology/wholeDevice"),
    hideInMenu: true,
  },
];

const household = [
  {
    name: "户储设备管理",
    title: "menu.933322",
    key: "933322",
    path: "/equipment/household/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/household/list"),
  },
  {
    name: "户储设备详情",
    title: "menu.EP_141226",
    key: "EP_141226",
    path: "/equipment/household/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/household/detail"),
    hideInMenu: true,
  },
  {
    name: "户储设备配置信息",
    title: "menu.EP_228385",
    key: "EP_228385",
    path: "/equipment/household/config",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/config/household/config"),
    hideInMenu: true,
  },
];

const chargerFaultReport = [
  {
    name: "充电桩故障上报列表",
    title: "menu.0401",
    key: "0401",
    path: "/exception/chargerFailure/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/errorReport/list"),
  },
  {
    name: "充电枪故障详情",
    title: "menu.269579",
    key: "269579",
    path: "/exception/chargerFailure/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/errorReport/detail"),
    hideInMenu: true,
  },
  {
    name: "设备安全认证信息",
    title: "menu.767469",
    key: "767469",
    path: "/exception/deviceAuthInfo/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/deviceAuth/list"),
  },
  {
    name: "设备异常统计",
    title: "menu.968604",
    key: "968604",
    path: "/exception/statistics",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/statistics"),
  },
  {
    name: "充电枪上锁失败统计详情",
    title: "menu.96860401",
    key: "96860401",
    path: "/exception/statistics/lock/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/statistics/lock/detail"),
    hideInMenu: true,
  },
];

const platformMonitorEvent = [
  {
    name: "平台监控充电桩事件列表",
    title: "menu.0402",
    key: "0402",
    path: "/exception/chargerEvent/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/eventMonitoring/list"),
  },
  {
    name: "平台监控事件详情",
    title: "menu.040201",
    key: "040201",
    path: "/exception/chargerEvent/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/eventMonitoring/detail"),
    hideInMenu: true,
  },
  {
    name: "运行数据",
    title: "menu.040202",
    key: "040202",
    path: "/exception/chargerEvent/runningData",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/eventMonitoring/threshold"),
    hideInMenu: true,
  },
];

const businessEnergyEvent = [
  {
    name: "工商能源事件",
    title: "menu.OMC_EP_834622",
    key: "OMC_EP_834622",
    path: "/exception/businessEnergy/event",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/businessEnergy/event"),
  },
];

const energyEquipmentFaultReport = [
  {
    name: "能源故障上报列表",
    title: "menu.0405",
    key: "0405",
    path: "/exception/energyFailure/list",
    component: "./exceptionManagement/EnergyFaultReportingList",
  },
];

const abnormalMonitor = [
  {
    name: "异常监控",
    title: "menu.120495",
    key: "120495",
    path: "/exception/abnormalMonitor/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/abnormalMonitoring/list"),
  },
  {
    name: "异常监控详情",
    title: "menu.610780",
    key: "610780",
    path: "/exception/abnormalMonitor/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/abnormalMonitoring/detail"),
    hideInMenu: true,
  },
  {
    name: "运行数据",
    title: "menu.433523",
    key: "433523",
    path: "/exception/abnormalMonitor/threshold",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/exception/abnormalMonitoring/threshold"),
    hideInMenu: true,
  },
];

const chargingOrder = [
  {
    name: "充电订单",
    title: "menu.0501",
    key: "0501",
    path: "/itom/order/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/maintain/orderlist"),
  },
  {
    name: "充电数据",
    title: "menu.chargeCourse",
    key: "chargeCourse",
    path: "/itom/order/chargeData",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/maintain/stubChargeCourse"),
    hideInMenu: true,
  },
];

const dischargingOrder = [
  {
    name: "放电订单",
    title: "menu.042899",
    key: "042899",
    path: "/itom/discharging/order/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/maintain/discharging/order/list"),
  },
  {
    name: "放电数据",
    title: "menu.OMC_EP_731866",
    key: "OMC_EP_731866",
    path: "/itom/discharging/order/data",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/maintain/discharging/order/dischargingData"),
  },
];

const startStopOrder = [
  {
    name: "运维启停订单",
    title: "menu.0506",
    key: "0506",
    path: "/itom/startStopOrder/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/maintain/startStopOrder/list"),
  },
];

const task = [
  {
    name: "任务管理",
    title: "menu.0503",
    key: "0503",
    path: "/itom/task/list",
    component: "./TaskManagement",
  },
  {
    name: "配置修改",
    title: "menu.050301",
    key: "050301",
    path: "/itom/task/modifyConfig",
    component: "./TaskManagement/batchConfigTask",
    hideInMenu: true,
  },
  {
    name: "固件升级",
    title: "menu.050302",
    key: "050302",
    path: "/itom/task/firmwareUpdate",
    component: "./TaskManagement/batchFramWorkUpdateV2",
    hideInMenu: true,
  },
  {
    name: "获取最新配置",
    title: "menu.050303",
    key: "050303",
    path: "/itom/task/fetchLatestConfig",
    component: "./TaskManagement/batchStubGetConfig",
    hideInMenu: true,
  },
  {
    name: "修改状态",
    title: "menu.050304",
    key: "050304",
    path: "/itom/task/modifyStatus",
    component: "./TaskManagement/batchChangeStatus",
    hideInMenu: true,
  },
  {
    name: "批量新增设备",
    title: "menu.050305",
    key: "050305",
    path: "/itom/task/batchAddEquipment",
    component: "./TaskManagement/BatchAddEquipment",
    hideInMenu: true,
  },
  {
    name: "批量桩群转移",
    title: "menu.OMC_698480",
    key: "OMC_698480",
    path: "/itom/task/batchChargerTransfer",
    component: "./TaskManagement/BatchChargerTransfer",
    hideInMenu: true,
  },
  {
    name: "设置屏保",
    title: "menu.765783",
    key: "765783",
    path: "/itom/task/setScreensaver",
    component: "./TaskManagement/BatchSetScreensaver",
    hideInMenu: true,
  },
];

const eSimCard = [
  {
    name: "eSIM卡管理",
    title: "menu.876953",
    key: "876953",
    path: "/itom/esim/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/maintain/esim/list"),
  },
  {
    name: "eSIM卡详情",
    title: "menu.OMC_EP_685512",
    key: "OMC_EP_685512",
    path: "/itom/esim/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/maintain/esim/detail"),
    hideInMenu: true,
  },
];

const chargerConnectionLog = [
  {
    name: "桩连平台日志",
    title: "menu.0502",
    key: "0502",
    path: "/log/chargerConnection",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/logService/operationLog/list"),
  },
];

const chargerCommunicationLog = [
  {
    name: "充电桩通讯日志",
    title: "menu.0510",
    key: "0510",
    path: "/log/chargerCommunication",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/logService/communicationLog/list"),
  },
];

const chargerLog = [
  {
    name: "充电桩日志",
    title: "menu.781441",
    key: "781441",
    path: "/log/charger",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/logService/chargerEquipmentLog"),
  },
  {
    name: "AI日志诊断",
    title: "menu.085990",
    key: "085990",
    path: "/log/ai/diagnostic",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/logService/ai/diagnostic"),
  },
  {
    name: "新建AI诊断任务",
    path: "/logService/ai/diagnostic/task/add",
    title: "menu.aiDiagnosticTaskAdd",
    key: "aiDiagnosticTaskAdd",
    hideInMenu: true,
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/logService/ai/diagnostic/task/add"),
  },
  {
    name: "AI诊断详情",
    path: "/logService/ai/diagnostic/task/detail",
    title: "menu.aiDiagnosticTaskDetail",
    key: "aiDiagnosticTaskDetail",
    hideInMenu: true,
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/logService/ai/diagnostic/task/detail"),
  },
];

const chargerOperationLog = [
  {
    name: "充电桩操作日志",
    title: "menu.803041",
    key: "803041",
    path: "/log/chargerOperation",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/logService/chargerOperationLog"),
  },
];

const energyCommunicationLog = [
  {
    name: "能源设备通讯日志",
    title: "menu.op_platform_0802",
    key: "op_platform_0802",
    path: "/log/energyCommunication",
    microAppPath: getMicroAppPath(SUB_APP_NAME.ENERGY, "/maintenance/log"),
  },
];

const householdLog = [
  {
    name: "户储设备日志",
    title: "menu.876198",
    key: "876198",
    path: "/log/household",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/logService/household/device"),
  },
];

const householdOperateLog = [
  {
    name: "户储操作日志",
    title: "menu.051204",
    key: "051204",
    path: "/log/householdOperate",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/logService/household/operate"),
  },
];

const statusCode = [
  {
    name: "状态码管理",
    title: "menu.9004",
    key: "9004",
    path: "/platformConfiguration/statusCode/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/errorCodeManage/list"),
  },
  {
    name: "状态码配置",
    title: "menu.900401",
    key: "900401",
    path: "/platformConfiguration/statusCode/config",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/errorCodeManage/errorCodeConfig"),
    hideInMenu: true,
  },
];

const firmwareVersionApi = [
  {
    name: "固件版本管理",
    title: "menu.9005",
    key: "9005",
    path: "/platformConfiguration/firmware/list",
    component: "./setting/firmwareManagement/ListV2",
  },
  {
    name: "新增固件",
    title: "menu.900501",
    key: "900501",
    path: "/platformConfiguration/firmware/add",
    component: "./setting/firmwareManagement/Edit",
    hideInMenu: true,
  },
  {
    name: "编辑固件",
    title: "menu.900502",
    key: "900502",
    path: "/platformConfiguration/firmware/edit",
    component: "./setting/firmwareManagement/Edit",
    hideInMenu: true,
  },
  {
    name: "删除固件版本",
    title: "menu.900506",
    key: "900506",
    path: "/platformConfiguration/firmware/deleteVersion",
    hideInMenu: true,
  },
  {
    name: "版本详情",
    title: "menu.newFirmwaredetail",
    key: "newFirmwaredetail",
    path: "/platformConfiguration/firmware/detail",
    component: "./setting/firmwareManagement/NewDetail",
    hideInMenu: true,
  },
];

const ftp = [
  {
    name: "FTP映射管理",
    title: "menu.0110",
    key: "0110",
    path: "/platformConfiguration/ftpMap/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/networkFTPConfig/list"),
  },
  {
    name: "新增FTP网络配置",
    title: "menu.011001",
    key: "011001",
    path: "/platformConfiguration/ftpMap/add",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/networkFTPConfig/add"),
    hideInMenu: true,
  },
];

const dispatchRule = [
  {
    name: "派单规则管理",
    title: "menu.591260",
    key: "591260",
    path: "/platformConfiguration/dispatchRules/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/dispatchRules/list"),
  },
  {
    name: "新建派单规则",
    title: "menu.356616",
    key: "356616",
    path: "/platformConfiguration/dispatchRules/add",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/dispatchRules/add"),
    hideInMenu: true,
  },
  {
    name: "编辑派单规则",
    title: "menu.368060",
    key: "368060",
    path: "/platformConfiguration/dispatchRules/edit",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/dispatchRules/edit"),
    hideInMenu: true,
  },
  {
    name: "查看派单规则",
    title: "menu.375990",
    key: "375990",
    path: "/platformConfiguration/dispatchRules/read",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/dispatchRules/read"),
    hideInMenu: true,
  },
];

const alarmRule = [
  {
    name: "告警规则管理",
    title: "menu.766142",
    key: "766142",
    path: "/platformConfiguration/alarmRules/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/alarmRules/list"),
  },
  {
    name: "新建告警规则",
    title: "menu.965626",
    key: "965626",
    path: "/platformConfiguration/alarmRules/add",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/alarmRules/add"),
    hideInMenu: true,
  },
  {
    name: "编辑告警规则",
    title: "menu.970782",
    key: "970782",
    path: "/platformConfiguration/alarmRules/edit",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/alarmRules/edit"),
    hideInMenu: true,
  },
  {
    name: "查看告警规则",
    title: "menu.976120",
    key: "976120",
    path: "/platformConfiguration/alarmRules/read",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/alarmRules/read"),
    hideInMenu: true,
  },
];

const versionServer = [
  {
    name: "版本服务器",
    title: "menu.836220",
    key: "836220",
    path: "/platformConfiguration/firmware/version-server/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/firmware/version-server/list"),
  },
  {
    name: "固件详情",
    title: "menu.EP_593464",
    key: "965626",
    path: "/platformConfiguration/firmware/version-server/detail",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/firmware/version-server/detail"),
    hideInMenu: true,
  },
  {
    name: "新增固件",
    title: "menu.EP_698248",
    key: "EP_698248",
    path: "/platformConfiguration/firmware/version-server/add",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/firmware/version-server/add"),
    hideInMenu: true,
  },
  {
    name: "编辑固件",
    title: "menu.EP_714591",
    key: "EP_714591",
    path: "/platformConfiguration/firmware/version-server/edit",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/platform/firmware/version-server/edit"),
    hideInMenu: true,
  },
];

const enterprise = [
  {
    name: "企业管理",
    title: "menu.9008",
    key: "9008",
    path: "/setting/companyaccount/accountconfiguration/list",
    component: "./setting/companyAccount/AccountConfiguration",
  },
  {
    name: "新建企业",
    title: "menu.20210712createcompany",
    key: "20210712createcompany",
    path: "/setting/companyaccount/accountconfiguration/create",
    component: "./setting/companyAccount/AccountConfiguration/Create",
    hideInMenu: true,
  },
];

const user = [
  {
    name: "用户管理",
    title: "menu.9001",
    key: "9001",
    path: "/setting/user/list",
    component: "./setting/companyAccount/UserManage",
  },
  {
    name: "修改密码",
    title: "menu.20210706password",
    key: "20210706password",
    path: "/setting/user/editpassword",
    component: "./setting/companyAccount/EditPassword",
    hideInMenu: true,
  },
];

const role = [
  {
    name: "角色列表",
    title: "menu.9003",
    key: "9003",
    path: "/setting/companyaccount/permissionsmanage/rolelist",
    component: "./setting/companyAccount/PermissionsManage/RoleList",
  },
];

const menu = [
  {
    name: "菜单管理",
    title: "menu.9013",
    key: "9013",
    path: "/setting/menu",
    component: "./setting/Menu",
  },
];

const operationLog = [
  {
    name: "操作日志",
    title: "menu.371467",
    key: "371467",
    path: "/setting/operatingLog",
    component: "./setting/OperatingLog",
  },
];

const systemNotification = [
  {
    name: "系统通知",
    title: "menu.103201",
    key: "103201",
    path: "/setting/notification/list",
    component: "./System/Notification/List",
  },
  {
    name: "通知详情",
    title: "menu.130986", // 未配置
    key: "130986",
    path: "/setting/notification/detail",
    component: "./System/Notification/Detail",
    hideInMenu: true,
  },
  {
    name: "新增通知",
    title: "menu.053794", // 未配置
    key: "053794",
    path: "/setting/notification/add",
    component: "./System/Notification/Add",
    hideInMenu: true,
  },
  {
    name: "编辑通知",
    title: "menu.092475", // 未配置
    key: "092475",
    path: "/setting/notification/edit",
    component: "./System/Notification/Add",
    hideInMenu: true,
  },
];

// 辅枪订单列表
const subGunOrderList = [
  {
    name: "辅枪订单列表",
    title: "menu.431117",
    key: "431117",
    path: "/itom/subGunOrder/list",
    microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/maintain/subGunOrder/list"),
  },
];

// =================================================================================================================================
// ============================================================= 分割线 =============================================================
// =================================================================================================================================

export default [
  {
    path: "/",
    component: "@/layouts/BasicLayout",
    routes: [
      {
        name: "登录",
        path: "/login",
        component: "./Login",
      },
      {
        path: "/",
        component: "@/layouts/SpiralAppLayout",
        routes: [
          {
            path: "/*",
            component: "@/pages/404.tsx",
          },
          {
            name: "首页",
            title: "menu.467650",
            key: "467650",
            path: "/home",
            microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/home"),
          },
          {
            name: "统计驾驶舱",
            title: "menu.943846",
            key: "943846",
            path: "/cockpit",
            microAppPath: getMicroAppPath(SUB_APP_NAME.EP, "/statistic/cockpit"),
          },
          {
            name: "消息中心",
            title: "menu.193529",
            key: "193529", // 未设置
            path: "/notification",
            component: "./System/Message/List",
          },
          {
            name: "场站管理",
            title: "menu.077489",
            key: "077489",
            path: "/station",
            routes: [...chargingStation, ...stationMonitor],
          },
          {
            name: "设备管理",
            title: "menu.215192",
            key: "215192",
            path: "/equipment",
            routes: [
              ...charger,
              ...chargingConnector,
              ...warehouseCharger,
              ...warehouseChargingConnector,
              ...materialBom,
              ...distributionCabinet,
              ...batterySwapCabinet,
              ...moduleRoutes,
              ...energyEquipment,
              ...businessEnergy,
              ...highVoltageEquipment,
              ...deviceTopology,
              ...household,
            ],
          },
          {
            name: "异常管理",
            title: "menu.064717",
            key: "064717",
            path: "/exception",
            routes: [
              ...chargerFaultReport,
              ...platformMonitorEvent,
              ...energyEquipmentFaultReport,
              ...abnormalMonitor,
              ...businessEnergyEvent,
            ],
          },
          {
            name: "运维管理",
            title: "menu.421903",
            key: "421903",
            path: "/itom",
            routes: [
              ...chargingOrder,
              ...dischargingOrder,
              ...startStopOrder,
              ...task,
              ...eSimCard,
              ...subGunOrderList,
            ],
          },
          {
            name: "日志服务",
            title: "menu.598633",
            key: "598633",
            path: "/log",
            routes: [
              ...chargerConnectionLog,
              ...chargerCommunicationLog,
              ...chargerLog,
              ...chargerOperationLog,
              ...energyCommunicationLog,
              ...householdLog,
              ...householdOperateLog,
            ],
          },
          {
            name: "平台配置",
            title: "menu.731748",
            key: "731748",
            path: "/platformConfiguration",
            routes: [
              ...statusCode,
              ...firmwareVersionApi,
              ...ftp,
              ...dispatchRule,
              ...alarmRule,
              ...versionServer,
            ],
          },
          {
            name: "报表管理",
            title: "menu.217301",
            key: "217301",
            path: "/report",
            routes: [],
          },
          {
            name: "系统设置",
            title: "menu.264427",
            key: "264427",
            path: "/setting",
            routes: [
              ...enterprise,
              ...user,
              ...role,
              ...menu,
              ...operationLog,
              ...systemNotification,
            ],
          },
        ],
      },
    ],
  },
];
